module.exports = __webpack_public_path__ + "img/linkedin.a49a09d5.svg";